var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93C9FF",
    d: "M0 0H170V170H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 5,
    y: 5,
    width: 74,
    height: 87,
    rx: 12,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 40,
    width: 99,
    height: 117,
    rx: 12,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96 134C96 128.477 100.477 124 106 124H122C127.523 124 132 128.477 132 134C132 139.523 127.523 144 122 144H106C100.477 144 96 139.523 96 134Z",
    fill: "#28A443"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.5 134C96.5 128.753 100.753 124.5 106 124.5H122C127.247 124.5 131.5 128.753 131.5 134C131.5 139.247 127.247 143.5 122 143.5H106C100.753 143.5 96.5 139.247 96.5 134Z",
    stroke: "#000",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 134C114.5 129.858 117.858 126.5 122 126.5C126.142 126.5 129.5 129.858 129.5 134C129.5 138.142 126.142 141.5 122 141.5C117.858 141.5 114.5 138.142 114.5 134Z",
    fill: "#000",
    fillOpacity: 0.1,
    stroke: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 70C24 64.4772 28.4772 60 34 60H50C55.5228 60 60 64.4772 60 70C60 75.5228 55.5228 80 50 80H34C28.4772 80 24 75.5228 24 70Z",
    fill: "#2255EF",
    fillOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 70C24.5 64.7533 28.7533 60.5 34 60.5H50C55.2467 60.5 59.5 64.7533 59.5 70C59.5 75.2467 55.2467 79.5 50 79.5H34C28.7533 79.5 24.5 75.2467 24.5 70Z",
    stroke: "#2255EF",
    strokeOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 70C26 65.5817 29.5817 62 34 62C38.4183 62 42 65.5817 42 70C42 74.4183 38.4183 78 34 78C29.5817 78 26 74.4183 26 70Z",
    fill: "#2255EF",
    fillOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 70C26.5 65.8579 29.8579 62.5 34 62.5C38.1421 62.5 41.5 65.8579 41.5 70C41.5 74.1421 38.1421 77.5 34 77.5C29.8579 77.5 26.5 74.1421 26.5 70Z",
    stroke: "#2255EF",
    strokeOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.994 151.974L141.989 151.974V151.586C141.989 150.044 140.739 148.794 139.197 148.794C137.655 148.794 136.404 150.044 136.404 151.586V148.515C136.404 146.974 135.154 145.724 133.612 145.724C132.07 145.724 130.82 146.974 130.82 148.515V145.724C130.82 144.182 129.477 142.932 127.935 142.932C126.393 142.932 125.056 144.275 125.056 145.817L125.049 136.791C125.049 135.25 123.799 134 122.257 134C120.715 134 119.465 135.25 119.465 136.791V154.889C119.465 154.889 116.608 146.313 112.589 148.356C111.184 149.07 110.596 150.766 111.295 152.179L116.49 162.69C116.49 162.69 119.702 169 125.302 169H132.748C137.889 169 142 164.834 142 159.695L141.994 151.974Z",
    fill: "#3578F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#step4_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.904 72.9049C131.356 73.7937 128.557 72.8493 126.998 70.6468C125.989 69.221 124.744 67.9653 123.298 66.9251C120.573 64.9646 117.358 63.9283 114 63.9283C110.643 63.9283 107.427 64.9646 104.702 66.9251C103.256 67.9652 102.012 69.2209 101.003 70.6468C99.4437 72.8494 96.6444 73.7937 94.0966 72.905L93.2161 72.5979C94.713 68.3066 97.4548 64.6354 101.145 61.9807C104.913 59.2699 109.358 57.8372 114 57.8372C118.642 57.8372 123.087 59.2699 126.855 61.9805C130.546 64.6353 133.287 68.3065 134.784 72.5976L133.904 72.9049Z",
    fill: "#0A1B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.251 100.946L128.528 98.8628L132.843 87.0072C134.35 82.8665 134.46 78.452 133.162 74.2412C131.864 70.0303 129.287 66.4445 125.71 63.8713C118.706 58.8324 109.294 58.8326 102.29 63.8713C98.7133 66.4446 96.1363 70.0303 94.838 74.2412C93.54 78.452 93.6502 82.8665 95.1574 87.0072L99.4725 98.8628L93.7489 100.946L89.4337 89.0906C87.4688 83.692 87.3249 77.9368 89.0173 72.4468C90.71 66.9569 94.0696 62.2817 98.7332 58.9268C107.865 52.3577 120.135 52.3577 129.267 58.9268C133.931 62.2817 137.29 66.9568 138.983 72.4468C140.675 77.9368 140.531 83.692 138.566 89.0906L134.251 100.946Z",
    fill: "#2255EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.707 107.337L103.159 108.992L96.4216 90.4812L100.969 88.8259C102.354 88.322 103.885 89.0358 104.388 90.4203L109.301 103.918C109.805 105.302 109.091 106.833 107.707 107.337Z",
    fill: "#0A1B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5825 109.847C98.9296 110.125 100.327 110.023 101.62 109.553L103.159 108.992L96.4217 90.4812L94.8826 91.0414C93.59 91.5118 92.4537 92.3324 91.6006 93.4114C89.9416 95.5095 89.4885 98.3175 90.4033 100.831L91.8962 104.933C92.811 107.446 94.9631 109.306 97.5825 109.847Z",
    fill: "#2255EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.293 107.337L124.841 108.992L131.578 90.4812L127.03 88.8259C125.646 88.322 124.115 89.0358 123.611 90.4203L118.699 103.918C118.195 105.302 118.908 106.833 120.293 107.337Z",
    fill: "#0A1B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.417 109.847C129.07 110.125 127.672 110.023 126.38 109.553L124.841 108.992L131.578 90.4812L133.117 91.0414C134.41 91.5118 135.546 92.3324 136.399 93.4114C138.058 95.5095 138.511 98.3175 137.597 100.831L136.104 104.933C135.189 107.446 133.037 109.306 130.417 109.847Z",
    fill: "#2255EF"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2786 20.8292C43.4584 20.8292 44.4148 19.8727 44.4148 18.6929C44.4148 17.5131 43.4584 16.5566 42.2786 16.5566C41.0987 16.5566 40.1423 17.5131 40.1423 18.6929C40.1423 19.8727 41.0987 20.8292 42.2786 20.8292ZM52.7698 25.7326C47.0114 19.2094 37.5541 19.1998 31.7876 25.7326H31.3311C30.5627 25.7326 29.9398 26.3555 29.9398 27.1238C29.9398 28.1186 30.634 28.6312 31.3311 28.6312H31.7705C30.5453 30.0863 29.6806 31.7177 29.1581 33.4211L22.7395 28.989L22.7382 28.9881C22.444 28.7786 22.1236 28.7589 21.8839 29.0318C21.799 29.1285 20.9325 30.1155 20.0925 31.0721C20.0161 31.1742 19.8896 31.4337 20.1919 31.8019V31.8021L29.8072 43.2996C31.2359 46.4436 33.8566 49.0907 37.5299 50.4448H47.0272C49.7776 49.431 51.9368 47.6933 53.4478 45.5656C54.4926 46.0507 55.8076 46.3231 57.0215 46.3231C61.4278 46.3231 64.9999 42.751 64.9999 38.3446C65 32.8153 59.5209 28.9956 54.2762 30.7874C53.8579 30.0369 53.3621 29.3145 52.7868 28.6312H53.2261C53.9164 28.6312 54.6174 28.1223 54.6174 27.1238C54.6174 26.3555 53.9943 25.7326 53.2261 25.7326H52.7698ZM57.0216 43.4378C56.3199 43.4378 55.4969 43.2948 54.8655 43.038C56.152 40.0435 56.3715 36.6259 55.4091 33.4564C58.7718 32.4573 62.1148 34.8985 62.1148 38.3446C62.1148 41.1575 59.8343 43.4378 57.0216 43.4378Z",
    fill: "#2255EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "step4_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(86 54)",
    d: "M0 0H56V56H0z"
  })))));
}

export default SvgStep4;